import { LuArrowRight, LuCalendarDays } from 'react-icons/lu';
import {
    Card,
    Connector,
    Eyebrow,
    Instruction,
    Leg,
    LegDate,
    LegLabel,
    Track,
} from './styles';

type Props = {
    id: number;
    checkIn: Date | string;
    checkOut: Date | string;
};

const formatDate = (value: Date | string) =>
    new Date(value).toLocaleDateString('pt-BR');

/**
 * Cartão de contexto da reserva no checkout do link de pagamento: mostra a
 * janela da estadia (check-in → check-out) para o cliente conferir que o link
 * é da reserva certa antes de pagar.
 */
export const ReservationContextCard = ({ id, checkIn, checkOut }: Props) => (
    <Card aria-label={`Reserva número ${id}`}>
        <Eyebrow>
            <LuCalendarDays size={15} aria-hidden />
            Reserva #{id}
        </Eyebrow>

        <div className="itinerary">
            <Leg>
                <LegLabel>Check-in</LegLabel>
                <LegDate>{formatDate(checkIn)}</LegDate>
            </Leg>

            <Connector aria-hidden>
                <Track>
                    <span className="line" />
                    <LuArrowRight size={16} />
                </Track>
            </Connector>

            <Leg className="end">
                <LegLabel>Check-out</LegLabel>
                <LegDate>{formatDate(checkOut)}</LegDate>
            </Leg>
        </div>

        <Instruction>
            Estas são as datas da sua estadia. Confira os produtos, horários e o
            lado antes de pagar para não precisar reagendar.
        </Instruction>
    </Card>
);
